import api from '@/apis/di/budgetItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance, computed } from 'vue';

import { useStore } from 'vuex';
import { ModuleBudgetItem } from '@/stores/moduleConst';
import { MSConstant } from '@/commons/wildcards/index.js';

// Combo grid Mục
export const useBudgetItemComboGrid = (comboboxDataRemote, comboboxLoadData, columnName) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetItemComboboxLoadData = (payload, row, column, custom) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      {
        Field: 'budget_item_type',
        Value: proxy.$ms.constant.BudgetItemType.Item,
      },
      { Field: 'inactive', Value: false, Ors: ors },
    ];
    if (payload.columns && !payload.columns.includes('misa_code_id')) {
      payload.columns += ',misa_code_id';
    }
    if (payload.columns && !payload.columns.includes('budget_group_item_code')) {
      payload.columns += ',budget_group_item_code';
    }

    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'budget_item_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const budgetItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã mục',
        dataField: 'budget_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên mục',
        dataField: 'budget_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    quickSearch: 'BudgetItemQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && x.budget_item_type == 2,
    },
    comboboxLoadData: onBudgetItemComboboxLoadData,
  };

  // const store = useStore();

  // const budgetItemCombo = computed(() => {
  //   const budgetItems = store.getters[`${ModuleBudgetItem}/items`];
  //   return budgetItems.filter(
  //     x => !x.inactive && x.budget_item_type === MSConstant.BudgetItemType.Item
  //   );
  // });
  // comboboxDataRemote['budget_item_code'] = budgetItemCombo;

  // Sự kiện load combo trên grid
  return {
    budgetItemComboConfig,
    onBudgetItemComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
